import { FormControl, Grid, MenuItem } from "@mui/material";
import { SelectLight } from "../../../common/components/styled/styled";
import CommonTextField from "../../../common/components/functional/commonTextField/CommonTextField";
import { SpinnerButton } from "../../../common/components/functional/spinnerButton/SpinnerButton";
import { useTranslation } from "react-i18next";
import { Controller, FieldValues, useFormContext } from "react-hook-form";
import { Service } from "../settingsApi";
import isEmpty from "../../../common/helpers/isEmpty";
import InputRow from "../InputRow";

type Props = {
  isLoading: boolean;
  onSubmit: (fieldValues: FieldValues) => void;
};

const TestingFormFields = ({ isLoading, onSubmit }: Props) => {
  const { t } = useTranslation("settings");
  const services = Object.values(Service);
  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
  } = useFormContext();

  const searchDisabled = !isEmpty(errors) || !isValid || isLoading;

  return (
    <>
      <Grid container alignItems="center" spacing={1}>
        <InputRow
          label={t("aggregateId")}
          field={
            <Controller
              name="id"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <CommonTextField
                  {...field}
                  fullWidth
                  error={!!errors.id}
                  size="small"
                  sx={{ maxWidth: "450px" }}
                  inputProps={{ maxLength: 128 }} // Aggregate id can have 128 chars
                />
              )}
            />
          }
        />
        <InputRow
          label={t("aggregateType")}
          field={
            <Controller
              name="aggregateType"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <CommonTextField
                  {...field}
                  fullWidth
                  error={!!errors.aggregateType}
                  size="small"
                  sx={{ maxWidth: "450px" }}
                />
              )}
            />
          }
        />
        <InputRow
          label={t("aggregateService")}
          field={
            <Controller
              name="service"
              control={control}
              rules={{ required: true }}
              render={({ field: { value, onChange } }) => (
                <FormControl fullWidth>
                  <SelectLight
                    sx={{ maxWidth: "450px" }}
                    size="small"
                    value={value}
                    error={!!errors.service}
                    onChange={onChange}
                  >
                    {services.map((service) => {
                      return service ? (
                        <MenuItem key={service} value={service}>
                          {service}
                        </MenuItem>
                      ) : null;
                    })}
                  </SelectLight>
                </FormControl>
              )}
            />
          }
        />
      </Grid>
      <Grid item container>
        <Grid item xs={12}>
          <SpinnerButton
            label={t("common:search")}
            disabled={searchDisabled}
            onClick={handleSubmit(onSubmit)}
            variant="contained"
            color="primary"
            sx={{
              height: "36px",
              borderRadius: "20px",
              marginBottom: "20px",
              marginTop: "20px",
            }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default TestingFormFields;
